export const apiField = 's5_roof_material';

const makeOptions = data => data.map(item => typeof item === 'object' ? item : ({ value: item, name: item }));


function makeConfig(data: string[]) {
  return {
    label: 's5RoofMaterial',
    type: 'Select',
    apiField,
    missing: undefined,
    tooltip: undefined,
    data: data.map(item => ({ value: item, name: item })),
  };
}



export default function s5RoofMaterial(filteredRoofMaterialValues: string[]) {
  return makeConfig(filteredRoofMaterialValues);
}